// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollMenu_container__grYRw","menu":"ScrollMenu_menu__O1Xp1"};